import React, { useState, useRef } from 'react';
import logo from "../../../images/ensenartecorto.png";
import firmaCoordinador from "../../../images/firma-coordinador.png";
import firmaRector from "../../../images/firma-rector.png";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Source+Serif+4:wght@400;600&family=DM+Sans:wght@400;500;600;700&display=swap');

  /* ─── RESET TOTAL DE INPUTS ─── */
  input, textarea, select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none !important;
    border-top: none !important;
    border-right: none !important;
    border-bottom: none !important;
    border-left: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
    font-family: 'DM Sans', Arial, sans-serif;
  }
  input:focus, textarea:focus { outline: none !important; box-shadow: none !important; }

  * { margin: 0; padding: 0; box-sizing: border-box; }

  body {
    background: #eef0f4;
    padding: 18px;
    font-family: 'DM Sans', Arial, sans-serif;
    color: #1a1a2e;
  }

  .gb-wrap { max-width: 980px; margin: auto; }

  /* ─── TOOLBAR ─── */
  .gb-toolbar {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-bottom: 14px;
  }

  .gb-btn {
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    font-size: 13px;
    font-family: 'DM Sans', Arial, sans-serif;
    transition: opacity .18s, transform .12s;
  }
  .gb-btn:hover { opacity: .88; transform: translateY(-1px); }
  .gb-btn-add { background: #1d9e75; color: #fff; }
  .gb-btn-add-col { background: #5b4ab7; color: #fff; }
  .gb-btn-pdf { background: #185fa5; color: #fff; }

  /* ─── BOLETIN CARD ─── */
  .gb-boletin {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #d5d9e0;
    box-shadow: 0 3px 14px rgba(0,0,0,.07);
  }

  /* ─── HEADER ─── */
  .gb-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 2px solid #e5e9ef;
  }
  .gb-header-left { display: flex; align-items: center; gap: 18px; }
  .gb-logo { width: 180px; height: auto; object-fit: contain; }
  .gb-school h1 { font-size: 19px; color: #0d3b66; font-weight: 700; margin-bottom: 4px; }
  .gb-school p { font-size: 12px; color: #667; margin-bottom: 2px; }
  .gb-fecha {
    background: #eef4ff;
    color: #0d3b66;
    padding: 10px 15px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
  }

  /* ─── SECTIONS ─── */
  .gb-section { padding: 16px 24px; border-bottom: 1px solid #eceef2; }
  .gb-section-title {
    font-size: 12px;
    font-weight: 700;
    color: #0d3b66;
    letter-spacing: .07em;
    text-transform: uppercase;
    margin-bottom: 14px;
  }

  /* ─── INFO GRID ─── */
  .gb-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }
  .gb-field { display: flex; flex-direction: column; gap: 4px; }
  .gb-field label { font-size: 11px; color: #667; font-weight: 600; letter-spacing: .04em; }

  /* ─── INPUTS: NO BORDER LINES ─── */
  .gb-input {
    width: 100%;
    border: none;
    outline: none;
    padding: 6px 0;
    font-size: 13px;
    font-family: 'DM Sans', Arial, sans-serif;
    background: transparent;
    color: #111;
  }
  .gb-input:focus { color: #185fa5; }

  /* ─── TABLE ─── */
  .gb-table-wrap { overflow-x: auto; }
  table { width: 100%; border-collapse: collapse; min-width: 500px; }

  thead th {
    background: #f4f6fb;
    color: #0d3b66;
    padding: 9px 10px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .05em;
    text-transform: uppercase;
    border-bottom: 2px solid #dde1ea;
  }
  th.col-asig { text-align: left; width: 40%; }
  th.col-nota { text-align: center; }
  th.col-def  { text-align: center; width: 110px; }
  th.col-act  { text-align: center; width: 90px; }

  tbody td {  border-bottom: 1px solid #f0f1f4; font-size: 13px; }
  td.col-asig { text-align: left; }
  td.col-nota { text-align: center; }
  td.col-def  { text-align: center; font-weight: 700; color: #1d9e75; }
  td.col-act  { text-align: center; }

  .gb-td-input {
    border: none;
    outline: none;
    background: transparent;
    font-family: 'DM Sans', Arial, sans-serif;
    font-size: 13px;
    color: #111;
    text-align: center;
    width: 72px;
  }
  .gb-td-input-asig {
    border: none; outline: none;
    background: transparent;
    font-family: 'DM Sans', Arial, sans-serif;
    font-size: 13px;
    color: #111;
    width: 100%;
  }

  .gb-btn-del {
    background: #e24b4a;
    color: #fff;
    border: none;
    padding: 5px 10px;
    font-size: 11px;
    font-weight: 700;
    border-radius: 5px;
    cursor: pointer;
    font-family: 'DM Sans', Arial, sans-serif;
  }
  .gb-btn-del:hover { opacity: .8; }

  /* ─── SUMMARY ─── */
  .gb-summary { display: grid; grid-template-columns: repeat(2, 1fr); gap: 14px; }
  .gb-summary-card {
    border: 1px solid #dde1ea;
    border-radius: 10px;
    background: #f8f9fc;
    padding: 16px;
    text-align: center;
  }
  .gb-summary-card h3 { font-size: 12px; color: #667; margin-bottom: 6px; font-weight: 600; }
  .gb-summary-card p { font-size: 28px; font-weight: 700; color: #0d3b66; }

  /* ─── OBSERVACIONES ─── */
  .gb-obs {
  border: none;
  outline: none;
  width: 100%;
  font-size: 13px;
  font-family: 'DM Sans', Arial, sans-serif;
  background: transparent;
  resize: none;
  min-height: 70px;
  color: #111;
  line-height: 1.7;

  overflow: hidden; /* 🔥 quita el scroll */
}

  /* ─── FIRMAS ─── */
  .gb-sigs {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 50px;
    margin-top: 26px;
  }
  .gb-sig { text-align: center; }
  .gb-sig-line { border-top: 1px solid #aaa; margin-bottom: 7px; }
  .gb-sig p { font-size: 12px; color: #555; }

  /* ─── TOOLBAR REMOVE COL BTN ─── */
  .gb-btn-rm-col {
    background: none;
    border: none;
    color: #e24b4a;
    font-weight: 700;
    font-size: 11px;
    cursor: pointer;
    padding: 2px 6px;
    font-family: 'DM Sans', Arial, sans-serif;
  }
  .gb-btn-rm-col:hover { opacity: .7; }

  /* ══════════════════ PDF MODE ══════════════════ */
  @media print {
    body { background: #fff; padding: 0; }
    .gb-toolbar, .gb-col-act-header, .gb-col-act-cell,
    .gb-btn-del, .gb-btn-rm-col { display: none !important; }
    .gb-boletin { box-shadow: none; border: none; border-radius: 0; }
  }

  /* Ocultar todo en pdf-mode via JS (html2pdf) */
  .pdf-mode .gb-toolbar { display: none !important; }
  .pdf-mode .gb-col-act-header,
  .pdf-mode .gb-col-act-cell { display: none !important; }
  /* Ocultar TODAS las columnas de nota extra (n1, n2, n3...) en PDF */
  .pdf-mode [data-nota-extra="true"] { display: none !important; }
  /* Inputs y textareas sin ningún borde ni sombra */
  .pdf-mode input,
  .pdf-mode textarea {
    border: none !important;
    border-top: none !important;
    border-right: none !important;
    border-bottom: none !important;
    border-left: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
    pointer-events: none;
  }

  @media (max-width: 700px) {
    .gb-header { flex-direction: column; gap: 14px; align-items: flex-start; }
    .gb-grid, .gb-summary, .gb-sigs { grid-template-columns: 1fr; }
  }
`;

function GenerarBoletin() {
  const ref = useRef();

  const crearNotasBase = (extraNotas) => {
  const notas = {};
  for (let i = 0; i <= extraNotas; i++) {
    notas[`n${i}`] = '';
  }
  return notas;
};

const [materias, setMaterias] = useState([
  { nombre: 'Español', notas: crearNotasBase(0) },
  { nombre: 'Ciencias Sociales', notas: crearNotasBase(0) },
  { nombre: 'Ciencias Naturales', notas: crearNotasBase(0) },
  { nombre: 'Inglés', notas: crearNotasBase(0) },
  { nombre: 'Matemáticas', notas: crearNotasBase(0) },
  { nombre: 'Etica', notas: crearNotasBase(0) },
  { nombre: 'Educacion Fisica', notas: crearNotasBase(0) },
  { nombre: 'Comportamiento', notas: crearNotasBase(0) },
  { nombre: 'Proyecto', notas: crearNotasBase(0) },
]);
  const [extraNotas, setExtraNotas] = useState(0); // cuántas columnas de nota adicionales
  const [estudiante, setEstudiante] = useState('');
  const [documento, setDocumento] = useState('');
  const [programa, setPrograma] = useState('');
  const [director, setDirector] = useState('');
  const [anio, setAnio] = useState('2025');
  const [periodo, setPeriodo] = useState('Período 1');
  const [observaciones, setObservaciones] = useState('');

  const agregarMateria = () => {
    const notas = {};
    for (let i = 0; i <= extraNotas; i++) notas[`n${i}`] = '';
    setMaterias([...materias, { nombre: '', notas }]);
  };

  const eliminar = (idx) => setMaterias(materias.filter((_, i) => i !== idx));

  const actualizarNombre = (idx, val) => {
    const m = [...materias];
    m[idx].nombre = val;
    setMaterias(m);
  };

  const actualizarNota = (idx, key, val) => {
    const regex = /^(50|[0-4]?\d)?(\.\d{0,2})?$/;
    if (val === '' || regex.test(val)) {
      const m = [...materias];
      m[idx].notas[key] = val;
      setMaterias(m);
    }
  };

  const agregarColumna = () => {
    const idx = extraNotas + 1;
    const m = materias.map(mat => {
      const notas = { ...mat.notas, [`n${idx}`]: '' };
      return { ...mat, notas };
    });
    setMaterias(m);
    setExtraNotas(idx);
  };

  const quitarColumna = () => {
    if (extraNotas === 0) return;
    const key = `n${extraNotas}`;
    const m = materias.map(mat => {
      const notas = { ...mat.notas };
      delete notas[key];
      return { ...mat, notas };
    });
    setMaterias(m);
    setExtraNotas(extraNotas - 1);
  };

  const calcularDefinitiva = (mat) => {
    const vals = Object.values(mat.notas)
      .map(v => parseFloat(v))
      .filter(v => !isNaN(v));
    if (vals.length === 0) return '—';
    return (vals.reduce((a, b) => a + b, 0) / vals.length).toFixed(1);
  };

  const promedioGeneral = () => {
    if (materias.length === 0) return '0.0';
    const defs = materias
      .map(mat => parseFloat(calcularDefinitiva(mat)))
      .filter(v => !isNaN(v));
    if (defs.length === 0) return '0.0';
    return (defs.reduce((a, b) => a + b, 0) / defs.length).toFixed(1);
  };

  const reprobadas = () =>
    materias.filter(mat => {
      const d = parseFloat(calcularDefinitiva(mat));
      return !isNaN(d) && d < 3.5;
    }).length;

  const generarPDF = () => {
  const el = ref.current;

  // Activar modo impresión (tu CSS ya está perfecto)
  el.classList.add('pdf-mode');

  // Pequeño delay para asegurar que el DOM aplique estilos
  setTimeout(() => {
    window.print();

    // Quitar modo pdf después de imprimir
    setTimeout(() => {
      el.classList.remove('pdf-mode');
    }, 500);
  }, 300);
};

  const notaLabels = (i) => i === 0 ? 'Nota 1' : `Nota ${i + 1}`;

  return (
    <>
      <style>{styles}</style>
      <div className="gb-wrap">
        {/* TOOLBAR */}
        <div className="gb-toolbar">
          <button className="gb-btn gb-btn-add" onClick={agregarMateria}>+ Agregar Materia</button>
          {extraNotas < 4 && (
            <button className="gb-btn gb-btn-add-col" onClick={agregarColumna}>+ Nota extra</button>
          )}
          {extraNotas > 0 && (
            <button className="gb-btn" style={{background:'#dc3545',color:'#fff'}} onClick={quitarColumna}>− Quitar nota</button>
          )}
          <button className="gb-btn gb-btn-pdf" onClick={generarPDF}>Generar PDF</button>
        </div>

        {/* BOLETIN */}
        <div className="gb-boletin" ref={ref}>

          {/* HEADER */}
          <div className="gb-header">
            <div className="gb-header-left">
              <img src={logo} className="gb-logo" alt="Logo Enseñarte" />
              <div className="gb-school">
                <h1>Asociación Mundial Enseñarte – Holdme</h1>
                <p>NIT: 901922413-3</p>
                <p>Funza, Cundinamarca</p>
              </div>
            </div>
            <div className="gb-fecha">
              Fecha: {new Date().toLocaleDateString('es-CO')}
            </div>
          </div>

          {/* INFORMACIÓN DEL ESTUDIANTE */}
          <div className="gb-section">
            <div className="gb-section-title">Información del Estudiante</div>
            <div className="gb-grid">
              {[
                ['Nombres y Apellidos', estudiante, setEstudiante, 'text'],
                ['Documento', documento, setDocumento, 'text'],
                ['Programa', programa, setPrograma, 'text'],
                ['Director(a) de Grupo', director, setDirector, 'text'],
                ['Año Lectivo', anio, setAnio, 'number'],
                ['Número de Período', periodo, setPeriodo, 'text'],
              ].map(([label, val, setter, type]) => (
                <div className="gb-field" key={label}>
                  <label>{label}</label>
                  <input
                    className="gb-input"
                    type={type}
                    value={val}
                    onChange={e => setter(e.target.value)}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* TABLA ACADÉMICA */}
          <div className="gb-section">
            <div className="gb-section-title">Rendimiento Académico</div>
            <div className="gb-table-wrap">
              <table>
                <thead>
                  <tr>
                    <th className="col-asig">Asignatura</th>
                    {Array.from({ length: extraNotas + 1 }, (_, i) => (
                      <th
                        key={i}
                        className={`col-nota ${i > 0 ? 'gb-nota-extra-header' : ''}`}
                        style={{ minWidth: 90 }}
                      >
                        {notaLabels(i)}
                        {i > 0 && i === extraNotas && (
                          <button className="gb-btn-rm-col" onClick={quitarColumna} title="Quitar esta nota">✕</button>
                        )}
                      </th>
                    ))}
                    <th className="col-def">Definitiva</th>
                    <th className="col-act gb-col-act-header">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {materias.map((mat, idx) => (
                    <tr key={idx}>
                      <td className="col-asig">
                        <input
                          className="gb-td-input-asig"
                          type="text"
                          placeholder="Asignatura"
                          value={mat.nombre}
                          onChange={e => actualizarNombre(idx, e.target.value)}
                        />
                      </td>
                      {Array.from({ length: extraNotas + 1 }, (_, i) => (
                        <td
                          key={i}
                          className={`col-nota ${i > 0 ? 'gb-nota-extra-cell' : ''}`}
                        >
                          <input
                            className="gb-td-input"
                            type="text"
                            placeholder="0.0"
                            maxLength={5}
                            value={mat.notas[`n${i}`] ?? ''}
                            onChange={e => actualizarNota(idx, `n${i}`, e.target.value)}
                          />
                        </td>
                      ))}
                      <td className="col-def">{calcularDefinitiva(mat)}</td>
                      <td className="col-act gb-col-act-cell">
                        <button className="gb-btn-del" onClick={() => eliminar(idx)}>Eliminar</button>
                      </td>
                    </tr>
                  ))}
                  {materias.length === 0 && (
                    <tr>
                      <td colSpan={extraNotas + 3} style={{ textAlign: 'center', color: '#aaa', padding: '18px', fontSize: 13 }}>
                        Agrega materias con el botón de arriba
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* RESUMEN */}
          <div className="gb-section">
            <div className="gb-section-title">Resumen del Período</div>
            <div className="gb-summary">
              <div className="gb-summary-card">
                <h3>Promedio General</h3>
                <p>{promedioGeneral()}</p>
              </div>
              <div className="gb-summary-card">
                <h3>Materias Reprobadas</h3>
                <p>{reprobadas()}</p>
              </div>
            </div>
          </div>

          {/* OBSERVACIONES + FIRMAS */}
          <div className="gb-section">
            <div className="gb-section-title">Observaciones</div>
            <textarea
  className="gb-obs"
  value={observaciones}
  maxLength={750} // 🔥 límite
  onChange={(e) => {
    setObservaciones(e.target.value);

    // auto resize
    e.target.style.height = "auto";
    e.target.style.height = e.target.scrollHeight + "px";
  }}
/>
            <div className="gb-sigs">
  <div className="gb-sig" style={{ position: "relative", height: "90px" }}>
    <img
      src={firmaRector}
      style={{
        position: "absolute",
        top: "-50px",
        left: "50%",
        transform: "translate(-50%, 0) scale(0.48)", // 🔥 centrado perfecto + escala
        transformOrigin: "center",
        pointerEvents: "none"
      }}
    />
    <div className="gb-sig-line" style={{ marginTop: "50px" }} />
    <p>Rectora Gloria Marisol Diaz Acosta</p>
  </div>

  <div className="gb-sig" style={{ position: "relative", height: "90px" }}>
    <img
      src={firmaCoordinador}
      style={{
        position: "absolute",
        top: "-20px",
        left: "50%",
        transform: "translate(-50%, 0) scale(0.48)", // 🔥 centrado perfecto + escala
        transformOrigin: "center",
        pointerEvents: "none"
      }}
    />
    <div className="gb-sig-line" style={{ marginTop: "50px" }} />
    <p>Coordinadora Académica</p>
  </div>
</div>
          </div>

        </div>
      </div>
    </>
  );
}

export default GenerarBoletin;